import { lazy } from "react";
import { withSuspense } from "./routeHelpers";

const MyAccount = lazy(
  () =>
    import(/* webpackChunkName: "account" */ "../Account/MyAccount/MyAccount")
);
const Settings = lazy(
  () => import(/* webpackChunkName: "account" */ "../Account/Settings/Settings")
);
const ApiKeys = lazy(
  () => import(/* webpackChunkName: "account" */ "../Account/Settings/ApiKeys")
);

export default [
  {
    path: "/account/my-account",
    element: withSuspense(MyAccount),
  },
  {
    path: "/account/settings",
    element: withSuspense(Settings),
  },
  {
    path: "/account/settings/api-keys",
    element: withSuspense(ApiKeys),
  },
];
